module.exports = __webpack_public_path__ + "static/c12-6c02beaf92fb8962dfb46ad3e4ae0ee6.jpg";